import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Screen } from '../../shell/Screen';
import { EmptyState } from '../../components/EmptyState';

export function NotFoundPage() {
  const { t } = useTranslation('shell');
  return (
    <Screen title={t('notFound.title')} back="/">
      <EmptyState icon="compass" title={t('notFound.title')}>
        <Link to="/">{t('notFound.home')}</Link>
      </EmptyState>
    </Screen>
  );
}
